import { Injectable } from '@angular/core';
import { BehaviorSubject, firstValueFrom, map, switchMap, take } from 'rxjs';
import { environment } from '../../../environments/environment';
import { uuidV4 } from '../../utils/uuidUtil';
import { GoogleCardTokenizationRequest, GooglePayData } from '../api/api.models';
import { ApiService } from '../api/api.service';
import { ErrorService } from '../error/error.service';
import { ExternalDataService } from '../external-data/external-data.service';
import { GoogleComposerService } from './google-composer.service';

@Injectable({
  providedIn: 'root',
})
export class GooglePayService {
  public paymentsClient = new window.google.payments.api.PaymentsClient({
    environment: environment.IS_GOOGLE_PRODUCTION ? "PRODUCTION" : "TEST",
  });

  public $isReadyToPay = new BehaviorSubject(false);

  constructor(
    private apiService: ApiService,
    private externalDataService: ExternalDataService,
    private errorService: ErrorService,
    private googleComposer: GoogleComposerService
  ) {
    const isReadyToPayRequest = googleComposer.isReadyToPayRequest;
    
    this.paymentsClient
      .isReadyToPay(isReadyToPayRequest)
      .then((response) => {
        if (response['result']) {
          this.$isReadyToPay.next(true);
        }
      })
      .catch(function (err) {
        console.error(err);
      });
  }

  async pay() {
    const paymentDataRequest = await firstValueFrom(this.googleComposer.$paymentDataRequest);
    console.log(paymentDataRequest);
    

    this.paymentsClient
      .loadPaymentData(paymentDataRequest)
      .then((paymentData) => {
        this.doTokenization(paymentData as GooglePayData).subscribe({
          next: (response) => {
            this.externalDataService.sendParentSuccessResponse(response);
          },
          error: (error) => {
            this.errorService.handleApiError(error);
          },
        });
      })
      .catch((err) => {
        console.error(err);
      });
  }

  private doTokenization(paymentData: GooglePayData) {
    return this.externalDataService.$data
      .pipe(take(1))
      .pipe(
        map((externalData) => {
          const request: GoogleCardTokenizationRequest = {
            googlePayData: paymentData,
            companyId: +externalData.companyId,
            datetime: externalData.datetime,
            hmacFields: externalData.hmacFields,
            hmac: externalData.hmac,
          };

          return request;
        })
      )
      .pipe(
        switchMap((request) => {
          const uuid = uuidV4();
          return this.apiService.tokenizeFromGooglePayment(uuid, request);
        })
      );
  }
}
